import { Link } from "react-router-dom";

// Rend un paragraphe contenant des liens Markdown internes [ancre](/chemin)
// en vrais liens React Router stylés. Les URL externes ne sont pas autorisées.
const LINK_RE = /\[([^\]]+)\]\((\/[^)\s]*)\)/g;

export function renderWithLinks(text) {
  const parts = [];
  let last = 0;
  let m;
  let key = 0;
  while ((m = LINK_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push(
      <Link
        key={key++}
        to={m[2]}
        className="text-brand-golddark font-medium underline decoration-brand-gold/50 underline-offset-4 hover:decoration-brand-golddark transition-colors duration-300"
      >
        {m[1]}
      </Link>
    );
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
